import { Shipment } from '@app/types/generated';

type Carrier = {
  name?: string;
  imageUrl?: string;
  alt?: string;
  dropOffStep?: string;
  dropOffHeader?: string;
};

export const UPS = {
  name: 'UPS',
  imageUrl:
    'https://stockx-assets.imgix.net/shipping/Ups_Logo_Vector_02.jpg?auto=compress',
  alt: 'UPS Logo',
};

export const DHL = {
  name: 'DHL',
  imageUrl: 'https://stockx-assets.imgix.net/dhl-black-logo-vector.png',
  alt: 'DHL Logo',
};

export const SF_EXPRESS = {
  name: 'SF Express',
  imageUrl: 'https:///stockx-assets.imgix.net/SFExpress.png',
  alt: 'SF Express Logo',
};

export const ECMS = {
  name: 'ECMS Global',
  imageUrl: 'https:///stockx-assets.imgix.net/ecms_express_logo.png',
  alt: 'ECMS Global Logo',
};

export const YAMATO = {
  name: 'Yamato',
  imageUrl: 'https:///stockx-assets.imgix.net/yamato-logo.png',
  alt: 'Yamato Logo',
  dropOffStep: 'yamato_drop_off_instructions',
  dropOffHeader: 'yamato_drop_off_header',
};

export const FEDEX = {
  name: 'Fedex',
  imageUrl: 'https:///stockx-assets.imgix.net/fedex_logo.png',
  alt: 'Fedex Logo',
};

export const isYamato = (carrierCode: string) => carrierCode === 'YAMATO';

const getCarrier = (carrierCode: Shipment['carrierCode']): Carrier => {
  switch (carrierCode) {
    case 'UPS':
      return UPS;
    case 'DHL':
      return DHL;
    case 'SFEXPRESS':
      return SF_EXPRESS;
    case 'ECMS':
      return ECMS;
    case 'YAMATO':
      return YAMATO;
    case 'FEDEX':
      return FEDEX;
    default:
      return {};
  }
};

export default getCarrier;
